module.exports = __webpack_public_path__ + "static/media/lu.3ba095e9.svg";